import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { BUILD_VERSION } from "@/lib/buildTag";
import PresenzeMensaDocentiPage from "@/pages/PresenzeMensaDocentiPage";
import TabellaCorsiPage from "@/pages/TabellaCorsiPage";

const LOGO = "https://customer-assets.emergentagent.com/job_data-extraction-tool-8/artifacts/127arsv9_ccea6996-b7a7-4ac9-add3-72bd2e7d3685.png";
const BG = "linear-gradient(135deg, #122A4C 0%, #0A2B52 100%)";

function LoginScreen() {
  return (
    <div data-testid="portineria-login" style={{ minHeight: "100vh", background: BG, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.18)", borderRadius: 10, padding: "40px 34px", textAlign: "center", maxWidth: 420 }}>
        <img src={LOGO} alt="Istituto Canossiano" style={{ height: 70, marginBottom: 16 }} />
        <div style={{ color: "white", fontStyle: "italic", fontSize: 26, fontWeight: 700 }}>canossa<span style={{ color: "#ffdd00" }}>HUB</span></div>
        <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 14, margin: "6px 0 22px" }}>Portale Portineria</div>
        <a data-testid="portineria-login-btn" href={`${window.location.origin}/api/auth/google/login`}
          style={{ padding: "10px 20px", background: "#ffdd00", color: "#0A2B52", border: "none", fontSize: 13, fontWeight: 800, cursor: "pointer", borderRadius: 3, letterSpacing: 0.5, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 8 }}>
          <svg width="14" height="14" viewBox="0 0 18 18"><g>
            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.257h2.908c1.702-1.567 2.684-3.874 2.684-6.614z" fill="#4285F4" />
            <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.257c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853" />
            <path d="M3.964 10.712A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.712V4.956H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.044l3.007-2.332z" fill="#FBBC05" />
            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.956L3.964 7.288C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335" />
          </g></svg>
          ACCEDI CON GOOGLE
        </a>
      </div>
    </div>
  );
}

export function PortineriaShell({ title, children, backTo = "/portineria", backLabel = "← Portineria" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: "100vh", background: "#f4f6f8" }} data-testid="portineria-shell">
      <div style={{ background: BG, padding: "10px 20px", display: "flex", alignItems: "center", gap: 16 }}>
        <img src={LOGO} alt="logo" style={{ height: 42 }} />
        <div style={{ color: "white", fontStyle: "italic", fontSize: 18, fontWeight: 700 }}>canossa<span style={{ color: "#ffdd00" }}>HUB</span></div>
        <div style={{ color: "rgba(255,255,255,0.55)" }}>|</div>
        <div style={{ color: "white", fontWeight: 700, fontSize: 15 }}>{title}</div>
        <div style={{ marginLeft: "auto", display: "flex", gap: 10, alignItems: "center" }}>
          <button data-testid="portineria-back" onClick={() => navigate(backTo)}
            style={{ padding: "6px 12px", background: "rgba(255,255,255,0.12)", color: "white", border: "1px solid rgba(255,255,255,0.3)", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>{backLabel}</button>
          {user && <button data-testid="portineria-logout" onClick={logout}
            style={{ padding: "6px 12px", background: "rgba(255,255,255,0.12)", color: "white", border: "1px solid rgba(255,255,255,0.3)", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>ESCI</button>}
        </div>
      </div>
      <div style={{ maxWidth: 1500, margin: "0 auto", padding: 16 }}>{children}</div>
    </div>
  );
}

function AccessDenied() {
  const navigate = useNavigate();
  return (
    <div data-testid="portineria-denied" style={{ padding: 40, textAlign: "center", color: "#607d8b" }}>
      <div style={{ fontSize: 40, marginBottom: 10 }}>🔒</div>
      <div style={{ fontSize: 15, fontWeight: 700 }}>Non hai accesso a questa sezione.</div>
      <div style={{ fontSize: 13, marginTop: 6 }}>Chiedi all&apos;amministratore di abilitare la gestione &quot;Portineria&quot;.</div>
      <button onClick={() => navigate("/")} style={{ marginTop: 16, padding: "8px 16px", background: "#0A2B52", color: "white", border: "none", borderRadius: 3, cursor: "pointer", fontWeight: 700 }}>Torna alla Home</button>
    </div>
  );
}

// Wrapper per le route standalone /portineria/presenze e /portineria/corsi
export function PortineriaGuard({ need, title, children }) {
  const { user, loading, hasGestione } = useAuth();
  if (loading) return <div style={{ minHeight: "100vh", background: BG, display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>Caricamento…</div>;
  if (!user) return <LoginScreen />;
  const ok = (need || []).some(g => hasGestione(g));
  return <PortineriaShell title={title}>{ok ? children : <AccessDenied />}</PortineriaShell>;
}

// Wrapper standalone che mostra direttamente una pagina (per riuso in App.js)
export function PortineriaPresenzeRoute() {
  return <PortineriaGuard need={["portineria", "mensa"]} title="Presenze mensa docenti"><PresenzeMensaDocentiPage /></PortineriaGuard>;
}
// Rotta dedicata alla GESTIONE completa mensa docenti (3 schede: Anno scolastico / Mesi / Listino).
// Riservata ad admin o utenti col permesso "mense_docenti" — separata dalla gestione Portineria.
export function MensaDocentiGestioneRoute() {
  const { user, loading, hasGestione } = useAuth();
  if (loading) return <div style={{ minHeight: "100vh", background: BG, display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>Caricamento…</div>;
  if (!user) return <LoginScreen />;
  const ok = hasGestione("mense_docenti"); // true per admin o utenti col permesso "Mense docenti"
  return (
    <PortineriaShell title="Gestione mensa docenti" backTo="/" backLabel="← Hub">
      {ok ? <PresenzeMensaDocentiPage gestione /> : <AccessDenied />}
    </PortineriaShell>
  );
}
export function PortineriaCorsiRoute() {
  return <PortineriaGuard need={["portineria", "extra"]} title="Tabella corsi"><TabellaCorsiPage /></PortineriaGuard>;
}

const CARD = (color) => ({
  display: "flex", alignItems: "center", gap: 16, padding: "22px 26px", cursor: "pointer",
  background: "white", border: "1px solid #e0e0e0", borderLeft: `6px solid ${color}`,
  borderRadius: 8, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", transition: "transform .12s ease, box-shadow .12s ease",
});

export default function PortineriaPortal() {
  const { user, loading, hasGestione, logout } = useAuth();
  const navigate = useNavigate();
  if (loading) return <div style={{ minHeight: "100vh", background: BG, display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>Caricamento…</div>;
  if (!user) return <LoginScreen />;

  const allowed = hasGestione("portineria");

  return (
    <div style={{ minHeight: "100vh", background: BG, padding: 24 }} data-testid="portineria-portal">
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 28 }}>
          <img src={LOGO} alt="logo" style={{ height: 64 }} />
          <div>
            <div style={{ color: "white", fontStyle: "italic", fontSize: 26, fontWeight: 700 }}>canossa<span style={{ color: "#ffdd00" }}>HUB</span></div>
            <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 13 }}>Portale Portineria</div>
          </div>
          <div style={{ marginLeft: "auto", display: "flex", gap: 12, alignItems: "center" }}>
            <button onClick={() => navigate("/")} data-testid="portineria-home"
              style={{ padding: "8px 14px", background: "rgba(255,255,255,0.12)", color: "white", border: "1px solid rgba(255,255,255,0.3)", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>Hub</button>
            <button onClick={logout} data-testid="portineria-portal-logout"
              style={{ padding: "8px 14px", background: "rgba(255,255,255,0.12)", color: "white", border: "1px solid rgba(255,255,255,0.3)", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>ESCI</button>
          </div>
        </div>

        {!allowed ? (
          <div data-testid="portineria-portal-denied" style={{ background: "rgba(255,255,255,0.06)", border: "1px dashed rgba(255,255,255,0.25)", borderRadius: 8, padding: 32, textAlign: "center", color: "rgba(255,255,255,0.85)" }}>
            🔒 Non hai il permesso &quot;Portineria&quot;. Chiedi all&apos;amministratore di abilitarlo.
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
            <div data-testid="portineria-btn-presenze" onClick={() => navigate("/portineria/presenze")} style={CARD("#8e24aa")}
              onMouseOver={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.18)"; }}
              onMouseOut={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)"; }}>
              <div style={{ fontSize: 34 }}>🍽️</div>
              <div>
                <div style={{ fontSize: 16, fontWeight: 800, color: "#37474f" }}>Presenze mensa docenti</div>
                <div style={{ fontSize: 12, color: "#78909c", marginTop: 3 }}>Presenze insegnanti · addebito · saldi</div>
              </div>
            </div>
            <div data-testid="portineria-btn-corsi" onClick={() => navigate("/portineria/corsi")} style={CARD("#ef6c00")}
              onMouseOver={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.18)"; }}
              onMouseOut={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)"; }}>
              <div style={{ fontSize: 34 }}>🗂</div>
              <div>
                <div style={{ fontSize: 16, fontWeight: 800, color: "#37474f" }}>Corsi</div>
                <div style={{ fontSize: 12, color: "#78909c", marginTop: 3 }}>Docente · giorno · ora · piano · interno · uscita</div>
              </div>
            </div>
          </div>
        )}
        <div style={{ textAlign: "center", color: "rgba(255,255,255,0.35)", fontSize: 10, marginTop: 30 }}>v{BUILD_VERSION}</div>
      </div>
    </div>
  );
}
